import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import { FaCloudUploadAlt } from "react-icons/fa";

import { useMutation, useLazyQuery, useQuery } from "@apollo/client";
import { REPORT_SUBMIT } from "../../../../../queries";
import missionSetImage from "../../../../../assets/utils/images/mission_set.png";
import openInfo1 from "../../../../../assets/utils/images/openInfo2.png";
import fileUpImage from "../../../../../assets/utils/images/file_explain.png";
import discriptionImage from "../../../../../assets/utils/images/contract_discription.png";
import discriptionImage2 from "../../../../../assets/utils/images/contract_discription_2.png";
import discriptionImage3 from "../../../../../assets/utils/images/contract_discription_3.png";

import animetionLogo from "../../../../../assets/utils/images/animetion_logo.gif";

const SubmitReportCard = ({ obj, refetch }) => {
  const judgeDiscountAvailable =
    obj && obj.discountProgress && obj.discountProgress.discountAvailable;

  const [modal3, setModal3] = useState(false);
  const modalToggle3 = () => setModal3(!modal3);
  const [modal4, setModal4] = useState(false);
  const modalToggle4 = () => setModal4(!modal4);
  const [explainModal, setExplainModal] = useState(false);
  const explainModalToggle = () => setExplainModal(!explainModal);

  //書類アップロード
  const [submitReport, { loading, error, data }] = useMutation(REPORT_SUBMIT, {
    input: {
      orgId: obj.id,
      financialReport: financialReport,
      activityReport: activityReport,
    },
    onCompleted() {
      refetch();
    },
  });

  const [financialReport, setFinancialReport] = useState({
    name: "",
    file: "null",
  });
  const [activityReport, setActivityReport] = useState({
    name: "",
    file: "null",
  });

  // ローディング
  if (loading)
    return (
      <div className="loading__wrapper">
        <img
          style={{ width: "80px", margin: "auto" }}
          src={animetionLogo}
        ></img>
      </div>
    );
  if (error) return "...Return";

  // 書類セット
  const selectFinancialReport = (e) => {
    if (e.currentTarget.files !== null) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        if (file.size > 5500000) {
          alert(
            "5.5MBサイズまでのファイルしか送信できません、ファイルサイズをご確認ください。"
          );
          return;
        }
        setFinancialReport({
          name: file.name,
          file: e.target.result,
        });
      };
      // 必須
      reader.readAsDataURL(file);
    }
  };

  const selectActivityReport = (e) => {
    if (e.currentTarget.files !== null) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        if (file.size > 5500000) {
          alert(
            "5.5MBサイズまでのファイルしか送信できません、ファイルサイズをご確認ください。"
          );
          return;
        }
        setActivityReport({
          name: file.name,
          file: e.target.result,
        });
      };
      // 必須
      reader.readAsDataURL(file);
    }
  };

  const uploadFinancialReport = async () => {
    setModal3(!modal3);
    await refetch();
  };

  const uploadActivityReport = async () => {
    setModal4(!modal4);
    await refetch();
  };

  // 書類送信
  const uploadReports = async () => {
    if (financialReport.file === "null" || activityReport.file === "null") {
      alert("書類をアップロードしてください");
    } else {
      await submitReport({
        variables: {
          orgId: obj.id,
          financialReport: financialReport,
          activityReport: activityReport,
        },
      });
      setFinancialReport({
        name: "",
        file: "null",
      });
      setActivityReport({
        name: "",
        file: "null",
      });
      refetch();
    }
  };

  return (
    <div className="plan_right">
      <div className="button_area">
        <Button className="ema__btn__main" onClick={uploadReports}>
          報告書を提出
        </Button>
        <Button
          className={`button ema__btn__main ema__btn__update ${
            judgeDiscountAvailable ? "" : "disabled"
          }`}
          style={{ cursor: "initial" }}
        >
          <Link
            to={{
              pathname: `/pages/pricing`,
            }}
            style={{ color: "#fff", textDecoration: "none" }}
            className="text-center"
          >
            50%割引適用
          </Link>
        </Button>
        <a onClick={() => explainModalToggle()} className="explanation">
          ※ 割引を適用するには？
        </a>
      </div>
      <div className="comment_area">
        {obj && obj.discountProgress && obj.discountProgress ? (
          <p>
            {obj && obj.discountProgress && obj.discountProgress.latestComment}
          </p>
        ) : (
          <p>emaからのコメント</p>
        )}
      </div>
      <div className="upload_area">
        <ul className="ema__flex_row ema__align_items_center">
          {/* <li>
            <p>
              ステップ1
              <br />
              ミッション登録
            </p>
            <span>{financialReport.name}</span>
          </li> */}
          {/* <li>
           
            <p>
              ステップ2
              <br />
              組織認証
            </p>
            <span>{financialReport.name}</span>
          </li> */}
          <li onClick={modalToggle3}>
            <FaCloudUploadAlt style={{ width: 30, height: 30 }} />
            <p>事業報告書</p>
            <span>{financialReport.name}</span>
            <p>(ファイル容量: 5.5Mバイト以下)</p>
          </li>
          <li onClick={modalToggle4}>
            <FaCloudUploadAlt style={{ width: 30, height: 30 }} />
            <p>活動計算書・正味財産増減計算書等の財務報告書</p>
            <span>{activityReport.name}</span>
            <p>(ファイル容量: 5.5Mバイト以下)</p>
          </li>
        </ul>
      </div>

      <Modal isOpen={modal3} toggle={modalToggle3}>
        <ModalBody className="mt-4 ml-3 mr-3">
          <p className="bold">財務報告書をアップロード</p>
          <input type="file" onChange={selectFinancialReport} />
        </ModalBody>
        <ModalFooter style={{ background: "#fff", borderTop: "none" }}>
          <Button className="main_button" onClick={uploadFinancialReport}>
            アップロード
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modal4} toggle={modalToggle4}>
        <ModalBody className="mt-4 ml-3 mr-3">
          <p className="bold">活動報告書をアップロード</p>
          <input type="file" onChange={selectActivityReport} />
        </ModalBody>
        <ModalFooter style={{ background: "#fff", borderTop: "none" }}>
          <Button className="main_button" onClick={uploadActivityReport}>
            アップロード
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={explainModal} toggle={explainModalToggle}>
        <ModalBody className="mt-4 ml-3 mr-3">
          <p className="bold" style={{ marginBottom: 30 }}>
            以下の条件を満たすことで、50%割引を適用できます。
          </p>
          <div className="box" style={{ marginBottom: 50 }}>
            <p className="bold mb-2 ">1. 事業概要（ミッション）登録</p>
            <p className="ml-3">
              組織情報ページの【ミッションと連携方針】タブから、事業概要（ミッション）を登録
            </p>
            <img
              style={{ width: "100%", margin: "auto" }}
              src={missionSetImage}
            ></img>
          </div>

          <div className="box" style={{ marginBottom: 50 }}>
            <p className="bold mb-2">2. 情報開示と第三者認証</p>
            <p className="ml-3">「情報の編集」から各項目の情報を登録</p>
            <img
              style={{ width: "100%", margin: "auto" }}
              src={openInfo1}
            ></img>
          </div>

          <div className="box" style={{ marginBottom: 50 }}>
            <p className="bold mb-2">3. 財務報告書・活動報告書の提出</p>
            <p className="ml-3">
              組織情報ページの【契約プランとメンバー】タブから書類を提出
            </p>
            <img
              style={{ width: "100%", margin: "auto" }}
              src={fileUpImage}
            ></img>
          </div>

          {/* 適用後説明 */}
          <div className="box" style={{ marginBottom: 50 }}>
            <p className="bold mb-2">4. 審査通過後</p>
            <p className="ml-3">① 適用後、「50%割引適用」が赤く表示されます</p>
            <img
              style={{ width: "100%", margin: "auto" }}
              src={discriptionImage}
            ></img>
            <p className="mt-3 ml-3">
              ② 割引適用後のプラン一覧画面に移動します
            </p>
            <img
              style={{ width: "100%", margin: "auto" }}
              src={discriptionImage2}
            ></img>
            <p className="mt-3 ml-3">③ プラン適用画面</p>
            <img
              style={{ width: "100%", margin: "auto" }}
              src={discriptionImage3}
            ></img>
          </div>
        </ModalBody>
        <ModalFooter style={{ background: "#fff", borderTop: "none" }}>
          <Button
            className=""
            style={{ margin: "auto" }}
            onClick={explainModalToggle}
          >
            閉じる
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default SubmitReportCard;
